export const EVENT_ENDPOINTS = {
  CAMPAIGN_SUBMIT: '/v1/marketing/campaign/submit',
  CAMPAIGN_ENTRY_ACCEPT: '/v1/marketing/campaign_entry/accept',
  CAMPAIGN_CREATE: '/v1/marketing/campaign/create',
} as const

export type EventEndpoint = (typeof EVENT_ENDPOINTS)[keyof typeof EVENT_ENDPOINTS]

export interface CampaignSubmitPayload {
  custom: {
    session_id: string
    campaign_id: number
  }
}

export interface CampaignEntryAcceptPayload {
  custom: {
    user_influencer_id: number
    campaign_id: number
    campaign_entry_id: number
  }
}

export interface CampaignCreatePayload {
  custom: {
    session_id: string
  }
}

export type EventPayloadMap = {
  [EVENT_ENDPOINTS.CAMPAIGN_SUBMIT]: CampaignSubmitPayload
  [EVENT_ENDPOINTS.CAMPAIGN_ENTRY_ACCEPT]: CampaignEntryAcceptPayload
  [EVENT_ENDPOINTS.CAMPAIGN_CREATE]: CampaignCreatePayload
}

export type EventData<T extends EventEndpoint = EventEndpoint> = {
  endpoint: T
  payload: EventPayloadMap[T]
  timestamp: number
  id: string
}

export interface EventClientConfig {
  baseUrl: string
  bufferSize: number
  flushIntervalMs: number
  maxRetries: number
  backoffBaseMs: number
  storageKey: string
  concurrency: number
}
